import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import {ConfigService} from '../config/config.service';
import {Location} from '@angular/common';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslateService} from '@ngx-translate/core';
import {NgForm, UntypedFormControl, Validators, UntypedFormGroup} from '@angular/forms';
import {animate, style, transition, trigger} from '@angular/animations';
import {LanguageService} from '../service/language.service';
import {filter, switchMap} from 'rxjs/operators';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    animations: [
        trigger('fadeAnimation', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('400ms ease-in-out', style({ opacity: 1 }))
            ]),
            transition(':leave', [
                animate('400ms ease-in-out', style({ opacity: 0 }))
            ])
        ])
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class LoginComponent implements OnInit {

  constructor(private router: Router, private api: ConfigService, public location: Location,
              private snackBar: MatSnackBar, private translate: TranslateService,
              // tslint:disable-next-line:variable-name
              private _language: LanguageService) {
    this._language.current_lang.subscribe(lang => {
      if (lang === 0) {
        translate.use('ro');
      } else {
        translate.use('en');
      }
    });
  }


  isRegisterVisible = false;
  isLoaderVisible = false;
  hide = true;
  errorMessage = '';

  loginForm = new UntypedFormGroup({
    loginEmail: new UntypedFormControl('', [Validators.required, Validators.email]),
    loginPassword: new UntypedFormControl('', [Validators.required])
  });

  // tslint:disable-next-line:typedef
  get loginEmailFormControl() {
    return this.loginForm.get('loginEmail') as UntypedFormControl;
  }

  // tslint:disable-next-line:typedef
  get loginPasswordFormControl() {
    return this.loginForm.get('loginPassword') as UntypedFormControl;
  }

  submitLogin(): void {
    this.isLoaderVisible = true;
    this.api.Login(this.loginEmailFormControl.value, this.loginPasswordFormControl.value).subscribe(result => {
      // @ts-ignore
      localStorage.setItem('token', result.access_token);
      this.isLoaderVisible = false;
      this.router.navigate(['Market/0/all']);
    },  err => {
      let errorTranslate = 'errorOccurred';
      if (err.error.error === 'invalid_client' ) {
        errorTranslate = 'invalid_client';
      }
      this.translate.get(errorTranslate).subscribe(message => {
        this.errorMessage = message;
        this.isLoaderVisible = false;
        this.snackBar.open(message, '',
          {duration: 3000, panelClass: 'error-snack-bar',
            horizontalPosition: 'end', verticalPosition: 'top'});
      });
    });
  }

  login(): void {
    this.submitLogin();
  }

  toggleRegister(): void {
    this.isRegisterVisible = !this.isRegisterVisible;
  }

  goBack(): void {
    this.location.back();
  }

  ngOnInit(): void {

  }

}
